import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Variables d\'environnement Supabase manquantes:');
  console.error('  REACT_APP_SUPABASE_URL:', supabaseUrl);
  console.error('  REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? '(définie)' : '(manquante)');
  throw new Error('Missing Supabase environment variables. Please check .env file.');
}

console.log('✅ Supabase client initialisé avec URL:', supabaseUrl);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
});
